import React, { Fragment, useEffect, useState } from 'react'
import cardImg from '../../Assets/Images/cardImg.png'
import { Form } from 'react-bootstrap'
import { addUserCard, deleteCard, getCard, updateCard } from "../../Services/ProfileServices";
import toast from 'react-hot-toast';

const MyCardDetailTab = () => {

    const [addCard, setAddCard] = useState(false)
    const [editCard, setEditCard] = useState(false)
    const [cardNumber, setCardNumber] = useState("")
    const [cardName, setCardName] = useState("")
    const [cardMonth, setCardMonth] = useState("")
    const [cardYear, setCardYear] = useState("")
    const [allCard, setAllCards] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [cardId, setCardId] = useState("")



    const handleCardNumber = (e) => { setCardNumber(e.target.value) }
    const handleCardName = (e) => { setCardName(e.target.value) }
    const handleCardMonth = (e) => { setCardMonth(e.target.value) }
    const handleCardYear = (e) => { setCardYear(e.target.value) }


    const handleGetCard = async () => {
        let response = await getCard()
        if (response.statusCode === 200) {
            setAllCards(response?.response?.data)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }


    useEffect(() => {
        handleGetCard();
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (cardId) {
            setIsLoading(true)
            const body = {
                card_no: cardNumber, name: cardName, month: cardMonth, year: cardYear
            }

            let response = await updateCard(cardId, body)
            if (response.statusCode === 200) {
                toast?.success(response?.message)
                setIsLoading(false)
                handleGetCard();
                setEditCard(false)
                setCardId("")
            } else if (response.statusCode === 401) {
                toast?.error(response?.errors)
                setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                setIsLoading(false)
            }

        }
        else {
            setIsLoading(true)
            const body = {
                card_no: cardNumber, name: cardName, month: cardMonth, year: cardYear
            }

            let response = await addUserCard(body)
            if (response.statusCode === 200) {
                toast?.success(response?.message)
                setIsLoading(false)
                handleGetCard();
                setAddCard(false)
            } else if (response.statusCode === 401) {
                toast?.error(response?.errors)
                setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                setIsLoading(false)
            }

        }
        setIsLoading(false)
    }



    const handleDeleteCard = async (id) => {
        setIsLoading(true)
        let response = await deleteCard(id)
        if (response.statusCode === 200) {
            setIsLoading(false)
            toast?.success(response?.message)
            handleGetCard();
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)

    }


    const handleEdit = (item) => {
        setEditCard(true)
        setCardId(item?.id)
        setCardName(item?.name)
        setCardNumber(item?.card_no)
        setCardYear(item?.year)
        setCardMonth(item?.month)
    }

    return (
        <Fragment>
            <h5 className='fw-600 border-bottom pb-3 '>My Card Details</h5>


            {/* {editCard && (
                <>
                    <Form onSubmit={handleSubmit} className='row'>
                        <h5 className='s-16'>Edit New Card</h5>
                        <Form.Group className="mb-3 col-lg-12">
                            <Form.Control onChange={handleCardName}
                                type="text"
                                value={cardName}
                                className='border-0'
                                placeholder=" Name on Card" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-12">
                            <Form.Control
                                onChange={handleCardNumber}
                                type="text"
                                value={cardNumber}
                                className='border-0'
                                placeholder="Card Number" />
                        </Form.Group>
                        <Form.Group className="mb-3 d-none col-lg-6">
                            <Form.Control
                                type="text"
                                className='border-0'
                                placeholder="CVC" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                value={cardMonth}
                                onChange={handleCardMonth}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                type="number" className='border-0' placeholder="MM" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                value={cardYear}
                                onChange={handleCardYear}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                type="number" className='border-0' placeholder="YY" />
                        </Form.Group>

                        <div>
                            <button
                                type="button"
                                className='mb-3 btn btn-danger px-4 py-2'
                            >
                                Save Changes
                            </button>
                        </div>
                    </Form >
                </>
            )} */}



            {(addCard || editCard) &&
                (<>
                    <Form onSubmit={handleSubmit} className='row'>
                        <h5 className='s-16'>
                            {editCard ? "Edit" : "Add New "}
                            Card</h5>
                        <Form.Group className="mb-3 col-lg-12">
                            <Form.Control onChange={handleCardName}
                                type="text"
                                value={cardName}
                                className='border-0'
                                placeholder=" Name on Card" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-12">
                            <Form.Control
                                onChange={handleCardNumber}
                                type="text"
                                value={cardNumber}
                                className='border-0'
                                placeholder="Card Number" />
                        </Form.Group>
                        <Form.Group className="mb-3 d-none col-lg-6">
                            <Form.Control
                                type="text"
                                className='border-0'
                                placeholder="CVC" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                value={cardMonth}
                                onChange={handleCardMonth}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                type="number" className='border-0' placeholder="MM" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                value={cardYear}
                                onChange={handleCardYear}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                type="number" className='border-0' placeholder="YY" />
                        </Form.Group>

                        <div>
                            <button
                                type="submit"
                                className='mb-3 btn btn-danger px-4 py-2'
                            >
                                Save Changes
                            </button>
                        </div>
                    </Form >
                </>)}



            {(!editCard && !addCard) && (
                <>
                    {Array.isArray(allCard) && allCard.length > 0 ? (
                        allCard.map((item, i) => (
                            <div key={i} className="card p-2 border-0 bg-light mb-2">
                                <div className="row align-items-center">
                                    <div className="col-auto">
                                        <img src={cardImg} width={"77.35px"} height={"47.24px"} alt="" />
                                    </div>

                                    <div className="col ps-0">
                                        <h5 className='s-18 mb-0'>{item?.name}</h5>
                                        <p className='s-15 mb-0'>{item?.card_no}</p>
                                    </div>

                                    <div className="col-auto d-flex text-end">
                                        <p
                                            onClick={() => handleEdit(item)}
                                            className='s-15 me-2 cursor-pointer text-danger mb-0'
                                        >
                                            Edit
                                        </p>
                                        <div className="verticle-border" />
                                        <p
                                            onClick={() => handleDeleteCard(item?.id)}
                                            className='cursor-pointer s-15 mb-0 ms-2 text-muted'
                                        >
                                            Delete
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No cards available.</p>
                    )}

                    <div>
                        <button
                            type='button'
                            onClick={() => setAddCard(true)}
                            className='btn btn-danger px-4 py-3 mt-3'
                        >
                            Add New Card
                        </button>
                    </div>
                </>
            )}


        </Fragment>
    )
}

export default MyCardDetailTab